<template>
    <div class="profile-icon-l relative" @mouseover="openPopup" @mouseleave="closePopup">
        <usericon-popup :userId="topic.user_id" v-if="showPopup"></usericon-popup>
        <template v-if="showTrophy && topic.user().active_trophy">
            <template v-if="topic.user().active_trophy.icon">
                <trophy :trophy="topic.user().active_trophy"
                        :showTitle="false"
                        :showDesc="false"
                        :size="20"
                        :displayOnFeed="true"
                        orientation="horizontal">
                </trophy>
            </template>
        </template>
        <template v-if="!topic.named_user">
            <a :href="'/profile/' + topic.user().username">
                <img :src="topic.user().avatar" onerror="this.src='/img/avatar.png'">
            </a>
        </template>
        <template v-else>
            <a :href="'/profile/' + topic.named_user">
                <img :src="topic.named_user_avatar" onerror="this.src='/img/avatar.png'">
            </a>
        </template>
    </div>
</template>

<script>
    import UserIconPopup from './UserIconPopup.vue';

    export default {
        components: {'usericon-popup': UserIconPopup},
        data() {
            return {
                showPopup: false,
                timer: null,
                closeTimer: null
            }
        },
        props: {
            topic: {
                required: true
            },
            namedUser: {
                default: false
            },
            showTrophy: {
                default: true
            },
        },
        methods: {
            openPopup() {
                clearTimeout(this.timer);
                clearTimeout(this.closeTimer);

                this.timer = setTimeout(() => {
                    this.showPopup =  true;
                }, 350);
            },
            closePopup() {
                clearTimeout(this.timer);
                clearTimeout(this.closeTimer);

                this.closeTimer = setTimeout(() => {
                    this.showPopup =  false;
                }, 200);

            }
        }
    }
</script>